import styles from "../../../movein-checklist.module.css";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { X } from "react-feather";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";

const schema = yup.object().shape({
  bedroomfloorCovering: yup.string(),
  bedroomfloorCoveringOther: yup.string(),
  bedroomWallsCeiling: yup.string(),
  bedroomWallsCeilingOther: yup.string(),
  bedroomWindow: yup.string(),
  bedroomWindowOther: yup.string(),
  bedroomWindowConvering: yup.string(),
  bedroomWindowConveringOther: yup.string(),
  bedroomLightingFans: yup.string(),
  bedroomLightingFansOther: yup.string(),
  bedroomDoorHardware: yup.string(),
  bedroomDoorHardwareOther: yup.string(),
  bedroomHeating: yup.string(),
  bedroomHeatingOther: yup.string(),
  bedroomOutletsSwitches: yup.string(),
  bedroomOutletsSwitchesOther: yup.string(),
  bedroomSmokeAlarm: yup.string(),
  bedroomSmokeAlarmOther: yup.string(),
  bedroomOther: yup.string(),
  bedroomOtherOther: yup.string(),
});

const BedroomForm = ({ onSubmitArrivalForm, setLoading, moveInCheckListInfo, handleChange4 }) => {
  const [uploadedImages, setUploadedImages] = useState([]);
  const { getAccessTokenSilently } = useAuth0();

  const { control, handleSubmit, setValue } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const bedroomValues = useWatch({ control });

  useEffect(() => {
    if (!moveInCheckListInfo?.bedroom_data) return;

    const data = moveInCheckListInfo.bedroom_data;

    Object.entries(data).forEach(([key, field]) => {
      if (!field || typeof field !== "object") return;
    });

  }, [moveInCheckListInfo, setValue]);

  const onSubmit = (data) => {
    const sectionName = "bedroom_data";
    const formattedData = {
      bedroomfloorCovering: { value: data.bedroomfloorCovering === "other" ? data.bedroomfloorCoveringOther : data.bedroomfloorCovering, is_other: data.bedroomfloorCovering === "other" ? 1 : 0 },
      bedroomWallsCeiling: { value: data.bedroomWallsCeiling === "other" ? data.bedroomWallsCeilingOther : data.bedroomWallsCeiling, is_other: data.bedroomWallsCeiling === "other" ? 1 : 0 },
      bedroomWindow: { value: data.bedroomWindow === "other" ? data.bedroomWindowOther : data.bedroomWindow, is_other: data.bedroomWindow === "other" ? 1 : 0 },
      bedroomWindowConvering: { value: data.bedroomWindowConvering === "other" ? data.bedroomWindowConveringOther : data.bedroomWindowConvering, is_other: data.bedroomWindowConvering === "other" ? 1 : 0 },
      bedroomLightingFans: { value: data.bedroomLightingFans === "other" ? data.bedroomLightingFansOther : data.bedroomLightingFans, is_other: data.bedroomLightingFans === "other" ? 1 : 0 },
      bedroomDoorHardware: { value: data.bedroomDoorHardware === "other" ? data.bedroomDoorHardwareOther : data.bedroomDoorHardware, is_other: data.bedroomDoorHardware === "other" ? 1 : 0 },
      bedroomHeating: { value: data.bedroomHeating === "other" ? data.bedroomHeatingOther : data.bedroomHeating, is_other: data.bedroomHeating === "other" ? 1 : 0 },
      bedroomOutletsSwitches: { value: data.bedroomOutletsSwitches === "other" ? data.bedroomOutletsSwitchesOther : data.bedroomOutletsSwitches, is_other: data.bedroomOutletsSwitches === "other" ? 1 : 0 },
      bedroomSmokeAlarm: { value: data.bedroomSmokeAlarm === "other" ? data.bedroomSmokeAlarmOther : data.bedroomSmokeAlarm, is_other: data.bedroomSmokeAlarm === "other" ? 1 : 0 },
      bedroomOther: { value: data.bedroomOther === "other" ? data.bedroomOtherOther : data.bedroomOther, is_other: data.bedroomOther === "other" ? 1 : 0 }
    };

    const imageFiles = uploadedImages.map((img) => img.file_path);
    const imageSectionName = "bedroom_images";

    onSubmitArrivalForm(formattedData, sectionName, imageFiles, imageSectionName);
  };

  const handleImageChange = async (event) => {
    const files = Array.from(event.target.files);
    setLoading(true);

    try {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      for (const file of files) {
        const formData = new FormData();
        formData.append("image", file);

        const response = await axios.post(process.env.REACT_APP_PAYMENT_API_URL + `v1/move-in-report-file-upload`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          }
        });
        const { file_path, file_url } = response.data.data;

        setUploadedImages((prev) => [...prev, { file_path, file_url }]);
      }
      toast.success(`Images are uploaded`);
    } catch (error) {
      console.error("Upload error:", error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Image upload failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const removeImage = (fileNameToRemove) => {
    setUploadedImages((prev) => prev.filter((img) => img.file_path !== fileNameToRemove));
  };

  return (<div className={`${styles.FormSec}`}>
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>1. Floor and Floor Covering</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bedroomfloorCovering"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bedroomValues?.bedroomfloorCovering === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bedroomfloorCoveringOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>2. Walls and Ceiling</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bedroomWallsCeiling"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bedroomValues?.bedroomWallsCeiling === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bedroomWallsCeilingOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>3. Window(s)</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bedroomWindow"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bedroomValues?.bedroomWindow === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bedroomWindowOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>4. Window Covering(s)</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bedroomWindowConvering"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bedroomValues?.bedroomWindowConvering === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bedroomWindowConveringOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>5. Lighting Fixture(s)/Fans</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bedroomLightingFans"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bedroomValues?.bedroomLightingFans === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bedroomLightingFansOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>6. Door(s)/Hardware</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bedroomDoorHardware"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bedroomValues?.bedroomDoorHardware === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bedroomDoorHardwareOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>7. Heating</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bedroomHeating"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bedroomValues?.bedroomHeating === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bedroomHeatingOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>8. Outlets/Switches</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bedroomOutletsSwitches"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bedroomValues?.bedroomOutletsSwitches === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bedroomOutletsSwitchesOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>9. Smoke Alarms/CO Alarms</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bedroomSmokeAlarm"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bedroomValues?.bedroomSmokeAlarm === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bedroomSmokeAlarmOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>10. Other</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <Controller
                name="bedroomOther"
                control={control}
                render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
              />
            </FormControl>
          </div>
        </div>
      </div>

      <div className={`${styles.HalfSecFull}`}>
        <div className={`${styles.FileUpDuBUDiv}`}>
          <label htmlFor="file-upload-bedroom" className={`${styles.UploadLabel}`}>
            <span>
              <div className={`${styles.UpIcon}`}>
                <img src="/static/img/upload-floor.svg" alt="" />
              </div>
              <p>Upload Pictures</p>
              <p className={`${styles.UploadText}`}>File size upto 5 MB</p>
            </span>
          </label>
          <input id="file-upload-bedroom" type="file" accept="image/*" multiple onChange={handleImageChange} style={{ display: "none" }} />
        </div>

        <div className={`${styles.UpIMGSec}`}>
          {uploadedImages.map((img, index) => (<div key={index} className={`${styles.ImgFile}`}>
            <img src={img.file_url} alt={img.file_path} />
            <Button type="button" onClick={() => removeImage(img.file_path)}><X /></Button>
          </div>))}
        </div>
      </div>

      <div className={`${styles.ButtonAction}`}>
        <Button className={`${styles.CancelPopupBU}`} onClick={handleChange4("panel4")}>Cancel</Button>
        <Button type="submit" className={`${styles.SubmitPopupBU}`}>Save & Continue</Button>
      </div>
    </form>
  </div>);
};

export default BedroomForm;